import React from 'react';

function lorem() {
    return (
        <div>
             <p>
      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Adipiscing placerat 
      suspendisse pellentesque arcu. Massa tincidunt fermentum vitae, nisl ut feugiat 
      ligula turpis sceleri faucibus pulvinar
       blandit urna, accumsan nec, sodales massa em enim risus eget nullam sagittis, 
      </p>
        </div>
    )
}

export default lorem;
